import gql from 'graphql-tag';

export const GET_CLAIMS_VISIT_SUMMARY = gql`
  query GetClaimsVisitSummary($accountNumber: ID!) {
    guarantor {
      claims(accountNumber: $accountNumber) {
        cernerClaimNumber
        claimGeneratedDate
      }
    }
  }
`;
